export const textStock = {
    textStock: {
      tableHeaders: {
        table: {
          thickness: 'Espessura (MM)',
          side1: 'Lado 1 (L1)',
          side2: 'Lado 2 (L2)',
          lenght: 'Comprimento',
          quality: 'QUALIDADE',
          stock: 'PACOTES (U)',
          specialType: 'TIPO ESPECIAL',
          group: 'GRUPO (U)',
          ancho: 'LARGURA (MM)',
          largo: 'COMPRIMENTO (MM)',
          stockBobinas: 'STOCK EM BOBINA (KG)',
          paquetes2TM: 'BALOTES DE 2 TON (U)',
          paquetes2_5TM: 'BALOTES DE 2,5 TON (U)',
          paquetes3TM: 'BALOTES DE 3 TON (U)',
          rounds: 'REDONDOS',
          squares: 'QUADRADOS',
          rectangular: 'RETANGULARES',
          specials: 'ESPECIAIS',
          galvanized: 'GALVANIZADO',
          pickled: 'NEGRO/DECAPADO',
          availableStock: 'Stock disponível',
          limitedStock: 'Stock limitado',
          stockAvailability: 'Verifique a disponibilidade de todos os produtos do site e adicione diretamente ao carrinho.',
          noStock: 'Fora de stock'
        },
      },
    }
  };
  